import { render, staticRenderFns } from "./SecretariatCatalogs.vue?vue&type=template&id=1140e684&lang=pug&"
import script from "./SecretariatCatalogs.vue?vue&type=script&lang=ts&"
export * from "./SecretariatCatalogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports